function isoToDateConverter(
  isoDate: string | Date,
  month: "numeric" | "2-digit" | "long" | "short" | "narrow" = "short"
): string {
  const normalDate = new Date(isoDate);
  const formattedMonth = normalDate.toLocaleString("en-US", { month });

  return `${normalDate.getDate()} ${formattedMonth} ${normalDate.getFullYear()}`;
}

function isoToDateFormatter(
  isoDate: string | Date,
  month: "numeric" | "2-digit" | "long" | "short" | "narrow" = "short"
): string {
  const normalDate = new Date(isoDate);
  const formattedMonth = normalDate.toLocaleString("en-US", { month });
  const formattedDay = normalDate.toLocaleString("en-US", {
    day: "2-digit"
  });

  return `${formattedDay} ${formattedMonth} ${normalDate.getFullYear()}`;
}

function isValidDate(dateToCheck: string): boolean {
  if (dateToCheck.toLowerCase() === "null") {
    return false;
  }

  const date = new Date(dateToCheck);
  if (isNaN(date.getTime())) {
    return false;
  }

  return true;
}

export { isoToDateConverter, isoToDateFormatter, isValidDate };
